import { useState } from 'react';
import { AppBar, Toolbar, Container, Stack, Box, Drawer, List, ListItemButton, ListItemText, IconButton, Divider } from '@mui/material';
import { MenuOutlined as MenuIcon, CloseOutlined as CloseIcon } from '@mui/icons-material';
import { navigate } from '../lib/navigation';
import { track } from '../lib/analytics';
import Button from './Button';
import LogoMark from './LogoMark';

const NAV_LINKS = [
  { label: 'UGC opportunities', sectionId: 'ugc-opportunities' },
  { label: 'How it works', sectionId: 'how-it-works' },
  { label: 'For creators', sectionId: 'benefits' },
  { label: 'Example profile', href: '/example' },
  { label: 'Contact us', href: '/contact' },
];

function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function goToNavLink(link) {
  track('landing_nav_clicked', { path: window.location.pathname, label: link.sectionId || link.href });
  if (link.href) {
    navigate(link.href);
    return;
  }
  if (window.location.pathname === '/') {
    scrollToSection(link.sectionId);
  } else {
    navigate(`/?scrollTo=${link.sectionId}`);
  }
}

function Navbar({ authed }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <AppBar
      position="sticky"
      color="transparent"
      elevation={0}
      sx={{ bgcolor: '#FFFFFF', borderBottom: '1px solid', borderColor: 'divider' }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1, justifyContent: 'space-between' }}>
          <LogoMark />
          <Stack component="nav" aria-label="Main navigation" direction="row" spacing={3} sx={{ alignItems: 'center', display: { xs: 'none', md: 'flex' } }}>
            {NAV_LINKS.map((link) => (
              <Box
                key={link.label}
                component="button"
                onClick={() => goToNavLink(link)}
                sx={{
                  border: 0,
                  background: 'none',
                  cursor: 'pointer',
                  font: 'inherit',
                  fontWeight: 600,
                  color: 'text.primary',
                  '&:hover': { color: 'primary.main' },
                }}
              >
                {link.label}
              </Box>
            ))}
          </Stack>
          <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', display: { xs: 'none', md: 'flex' } }}>
            {authed ? (
              <Button onClick={() => navigate('/dashboard')}>My Dashboard</Button>
            ) : (
              <Button onClick={() => { track('landing_nav_clicked', { path: window.location.pathname, label: 'sign_in' }); navigate('/login'); }} sx={{ minHeight: 44 }}>Sign in</Button>
            )}
          </Stack>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', display: { xs: 'flex', md: 'none' } }}>
            {!authed && (
              <Button size="small" onClick={() => { track('landing_nav_clicked', { path: window.location.pathname, label: 'sign_in' }); navigate('/login'); }} sx={{ minHeight: 44 }}>
                Sign in
              </Button>
            )}
            <IconButton aria-label="Open menu" onClick={() => setMobileOpen(true)} sx={{ width: 44, height: 44 }}>
              <MenuIcon />
            </IconButton>
          </Stack>
        </Toolbar>
      </Container>

      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
        <Box sx={{ width: 280, py: 2 }} role="navigation" aria-label="Mobile">
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2, pb: 1 }}>
            <LogoMark />
            <IconButton aria-label="Close menu" onClick={() => setMobileOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider sx={{ mb: 1 }} />
          <List>
            {NAV_LINKS.map((link) => (
              <ListItemButton
                key={link.label}
                onClick={() => {
                  setMobileOpen(false);
                  goToNavLink(link);
                }}
              >
                <ListItemText primary={link.label} />
              </ListItemButton>
            ))}
          </List>
          <Box sx={{ px: 2, pt: 1 }}>
            <Button
              onClick={() => {
                setMobileOpen(false);
                track('landing_nav_clicked', { path: window.location.pathname, label: authed ? 'dashboard' : 'create_creatorcv' });
                navigate(authed ? '/dashboard' : '/signup');
              }}
              sx={{ width: '100%' }}
            >
              {authed ? 'My Dashboard' : 'Create your free CreatorCV'}
            </Button>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
}

export default Navbar;
